<template>
  <div class="cavasbox" ref="chart" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
import Chart from 'echarts'
export default {
  name: "myEchart",
  props:{
    option: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    option:{
      handler(val, oldval){

        if (this.chart) {
          this.chart.setOption(this.option); // 设置对应配置项
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.chart = Chart.init(this.$refs.chart); // 初始化echarts
    this.chart.setOption(this.option); // 设置对应配置项
    // 当窗口大小改变 echarts重置大小
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/charts/myEchart.vue